export default __webpack_public_path__ + "static/media/csv-icon.42e9290b.svg";